<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Masters <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> User Master <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Edit User</h1>
            <div class="content-wrap">
                <form [formGroup]="editUserForm">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="firstName" class="form-label">First Name</label>
                                <input type="text" placeholder="Enter the first name" formControlName="firstName" 
                                class="form-control form-input" id="firstName" [(ngModel)]="firstName">
                                <div class="invalid-feedback">
                                    <div>First Name is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="lastName" class="form-label">Last Name</label>
                                <input type="text" placeholder="Enter the last name" formControlName="lastName" 
                                class="form-control form-input" id="lastName" [(ngModel)]="lastName">
                                <div class="invalid-feedback">
                                    <div>Last Name is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="emailId" class="form-label">User Email</label>
                                <input type="text" placeholder="Enter the user email" formControlName="emailId" 
                                class="form-control form-input" id="emailId" [(ngModel)]="emailId">
                                <div class="invalid-feedback">
                                    <div>User Email is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group input-group-lg">
                                <label for="phoneNumber" class="form-label">Phone No.</label>
                                <div class="input-group-prepend">
                                    <span class="input-group-text">+91</span>
                                </div>
                                <input 
                                    type="text" 
                                    placeholder="Enter your phone no." 
                                    formControlName="phoneNumber"
                                    class="form-control form-input"
                                    id="phoneNumber"
                                    [(ngModel)]="phoneNumber"
                                />
                                <div class="invalid-feedback">
                                    <div>Phone no. is required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="roleId" class="form-label">Role</label>
                                <select formControlName="roleId" class="form-control form-input" id="roleId" [(ngModel)]="roleId">
                                    <option *ngFor="let role of roles" [ngValue]="role.id">{{role.rolename}}</option>
                                    
                                </select>
                                <div class="invalid-feedback">
                                    <div>Role is required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="proceed-btn bg-theme" (click)="editUser()">Submit</button>
                    <button class="proceed-btn" (click)="goBack()" >Cancel</button>
                </form>
            </div>
        </div>
    </div>
</div>

<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">

<div class="modal-content">
<div class="modal-header success-modal-header">
<h5 class="modal-title icon-title" id="resetPasswordModalLabel">
    <span class="icon-wrap"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
    <!-- <i class="fa fa-check fa-icon-modal"
        aria-hidden="true"></i> -->
    </h5>
</div>
<div class="modal-body">
<div class="row">
    <div class="col-md-12">
        <h3 class="success-text">Success</h3>
        <p class="reset-hd2">Record has been updated.</p>
    </div>
</div>
<button class="approve-modal-btn2 mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
</div>
</div>